import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import getters from './getter'
import tagsView from './modules/tagsView'
import common from './modules/common'
import sidebarAi from './modules/sidebarAi'
import billingAddonGuide from './modules/billingAddonGuide'
import trialFeatures from './modules/trialFeatures'
import cloneDeep from 'lodash/cloneDeep'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    app,
    tagsView,
    common,
    sidebarAi,
    billingAddonGuide,
    trialFeatures
  },
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js